import React from 'react';
import AuthByContract from 'containers/SignupPages/AuthByContract';
import AuthByContractEpargnSuccess from 'containers/SignupPages/AuthByContratEpargnSuccess';
import AuthByContractEpargnFailed from 'containers/SignupPages/AuthByContractEpargnFailed';
import AuthByContractEpargnSms from 'containers/SignupPages/AuthByContractEpargnSms';
import AuthByContractEpargnEmail from 'containers/SignupPages/AuthByContractEpargnEmail';
import AuthByContractEpargnEmailCodeInput from 'containers/SignupPages/AuthByContractEpargnEmailCodeInput';
import AuthUnvalidUserSms from 'containers/SignupPages/AuthUnvalidUserSms';
import AuthByContractSuccess from 'containers/SignupPages/AuthByContratSuccess';
import AuthByContractFailed from 'containers/SignupPages/AuthByCotractFailed';
import AuthBySms from 'containers/SignupPages/AuthBySms';
import AuthUnvalidUserSendEmail from 'containers/SignupPages/AuthUnvalidUserSendEmail';
import {
  AUTH_BY_CONTRACT,
  AUTH_BY_CONTRACT_EPARGN_SUCCESS,
  AUTH_BY_CONTRACT_EPARGN_SMS,
  AUTH_BY_CONTRACT_EPARGN_EMAIL,
  AUTH_BY_CONTRACT_EPARGN_EMAIL_CODE_INPUT,
  AUTH_BY_CONTRACT_EPARGN_FAILED,
  AUTH_BY_CONTRACT_FAILED,
  AUTH_BY_CONTRACT_SUCCESS,
  AUTH_BY_SMS,
  CONTRACT_FOUND_NOT_NUM,
  CONTRACT_NOT_FOUND,
  VERIFY_IDENTITY,
  CREATE_PASSWORD,
  ID_MEMO,
  AUTH_EPARGN_SMS_UNVALID_USER,
  PERSONAL_INFO,
  SEND_EMAIL_VERIFICATION_UNVALID_USER,
  ID_MEMO_EPARGN_UNVALID_USER,
  VERIFY_EMAIL_EPARGN_UNVALID_USER,
  CREATE_PASSWORD_EPARGN_UNVALID_USER,
} from 'containers/SignupPages/constants';
import ContractFoundNotNum from 'containers/SignupPages/ContractFoundNotNum';
import ContractNotFound from 'containers/SignupPages/ContractNotFound';
import CreatePassword from 'containers/SignupPages/CreatePassword';
import IdMemo from 'containers/SignupPages/IdMemo';
import PersonalInfo from 'containers/SignupPages/PersonalInfo';
import { CurrentSignupStepPropsType } from 'containers/SignupPages/types';
import VerifyIdentity from 'containers/SignupPages/VerifyIdentity';
import AuthEpargnUnvalidUserCodeInput from 'containers/SignupPages/AuthEpargnUnvalidUserCodeInputEmail';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';

const CurrentSignupStep = ({
  stepName,
  onSubmitStep,
  isLoading,
  setSignupStep,
}: CurrentSignupStepPropsType) => {
  switch (stepName) {
    case PERSONAL_INFO:
      return <PersonalInfo onSubmitStep={onSubmitStep} isLoading={isLoading} />;
    case AUTH_BY_CONTRACT_EPARGN_EMAIL:
      return (
        <AuthByContractEpargnEmail
          onSubmitStep={onSubmitStep}
          isLoading={isLoading}
          setSignupStep={setSignupStep}
        />
      );

    case AUTH_BY_SMS:
      return (
        <AuthBySms
          onSubmitStep={onSubmitStep}
          isLoading={isLoading}
          setSignupStep={setSignupStep}
        />
      );

    case AUTH_BY_CONTRACT_EPARGN_EMAIL_CODE_INPUT:
      return (
        <AuthByContractEpargnEmailCodeInput
          onSubmitStep={onSubmitStep}
          isLoading={isLoading}
          setSignupStep={setSignupStep}
        />
      );

    case AUTH_BY_CONTRACT_EPARGN_SUCCESS:
      return <AuthByContractEpargnSuccess setSignupStep={setSignupStep} />;
    case AUTH_BY_CONTRACT_EPARGN_SMS:
      return (
        <AuthByContractEpargnSms
          onSubmitStep={onSubmitStep}
          isLoading={isLoading}
          setSignupStep={setSignupStep}
        />
      );
    case AUTH_BY_CONTRACT_EPARGN_FAILED:
      return <AuthByContractEpargnFailed setSignupStep={setSignupStep} />;

    case CONTRACT_NOT_FOUND:
      return <ContractNotFound setSignupStep={setSignupStep} />;

    case VERIFY_IDENTITY:
      return (
        <VerifyIdentity
          setSignupStep={setSignupStep}
          onSubmitStep={onSubmitStep}
          isLoading={isLoading}
        />
      );

    case CONTRACT_FOUND_NOT_NUM:
      return <ContractFoundNotNum setSignupStep={setSignupStep} />;

    case AUTH_BY_CONTRACT:
      return (
        <AuthByContract onSubmitStep={onSubmitStep} isLoading={isLoading} />
      );

    case AUTH_BY_CONTRACT_SUCCESS:
      return <AuthByContractSuccess setSignupStep={setSignupStep} />;

    case AUTH_BY_CONTRACT_FAILED:
      return <AuthByContractFailed setSignupStep={setSignupStep} />;
    case AUTH_EPARGN_SMS_UNVALID_USER:
      return (
        <AuthUnvalidUserSms
          onSubmitStep={onSubmitStep}
          isLoading={isLoading}
          setSignupStep={setSignupStep}
        />
      );
    case SEND_EMAIL_VERIFICATION_UNVALID_USER:
      return (
        <AuthUnvalidUserSendEmail
          onSubmitStep={onSubmitStep}
          isLoading={isLoading}
          setSignupStep={setSignupStep}
        />
      );
    case VERIFY_EMAIL_EPARGN_UNVALID_USER:
      return (
        <AuthEpargnUnvalidUserCodeInput
          onSubmitStep={onSubmitStep}
          isLoading={isLoading}
          setSignupStep={setSignupStep}
        />
      );
    case ID_MEMO:
      return (
        <IdMemo
          setSignupStep={() => setSignupStep(AUTH_BY_CONTRACT)}
          onSubmitStep={onSubmitStep}
          isLoading={isLoading}
        />
      );
    case ID_MEMO_EPARGN_UNVALID_USER:
      return (
        <IdMemo
          setSignupStep={() => setSignupStep(VERIFY_EMAIL_EPARGN_UNVALID_USER)}
          onSubmitStep={onSubmitStep}
          isLoading={isLoading}
        />
      );

    case CREATE_PASSWORD:
      return (
        <GaLoadHOC category={EVENT_CATEGORIES.LOGIN_PARAMETERS}>
          <CreatePassword onSubmitStep={onSubmitStep} isLoading={isLoading} />
        </GaLoadHOC>
      );
    case CREATE_PASSWORD_EPARGN_UNVALID_USER:
      return (
        <CreatePassword onSubmitStep={onSubmitStep} isLoading={isLoading} />
      );
    default:
      return <PersonalInfo onSubmitStep={onSubmitStep} isLoading={isLoading} />;
  }
};

export default CurrentSignupStep;
